import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";

export class ShowingAdOverlay extends Phaser.GameObjects.Container {
    private pulseTween: Phaser.Tweens.Tween;

    constructor(scene: Phaser.Scene) {
        super(scene, GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2);

        this.scaleY = GameVars.scaleY;

        const height = GameConstants.GAME_HEIGHT / GameVars.scaleY;
        const background = new Phaser.GameObjects.Graphics(scene);
        background.fillStyle(0x051429, 0.85);
        background.fillRect(
            -GameConstants.GAME_WIDTH / 2,
            -height / 2,
            GameConstants.GAME_WIDTH,
            height,
        );
        background.setInteractive(
            new Phaser.Geom.Rectangle(
                -GameConstants.GAME_WIDTH / 2,
                -height / 2,
                GameConstants.GAME_WIDTH,
                height,
            ),
            Phaser.Geom.Rectangle.Contains,
        );
        this.add(background);

        const text = new Phaser.GameObjects.Text(scene, 0, 0, "LOADING", {
            fontFamily: "Teko",
            fontSize: "54px",
            color: "#ABEAFF",
        });
        text.setOrigin(0.5);
        text.setShadow(0, 0, "#00FFFF", 8);
        this.add(text);

        this.pulseTween = scene.tweens.add({
            targets: text,
            alpha: 0.25,
            ease: Phaser.Math.Easing.Sine.InOut,
            duration: 700,
            yoyo: true,
            repeat: -1,
        });

        scene.add.existing(this);
        this.setDepth(1000);
    }

    public destroy(): void {
        if (this.pulseTween) {
            this.pulseTween.stop();
            this.pulseTween = null;
        }

        super.destroy();
    }
}
